export default {
  name: 'cubeSpin'
};